import React, { useState, useContext } from 'react'

import validate from 'validate.js'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Typography from '@material-ui/core/Typography'
import Hidden from '@material-ui/core/Hidden'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { useTheme } from '@material-ui/core/styles'

import _appContext from '../../contexts/appContext'
import _userContext from '../../contexts/userContext'

import constraints from '../../utils/constraints'

const initialState = {
    emailAddress: '',
    password: '',
    errors: null,
}

function SignInDialog(props) {
    const [performingAction, setPerformingAction] = useState(
        initialState.performingAction
    )
    const [emailAddress, setEmailAddress] = useState(initialState.emailAddress)
    const [password, setPassword] = useState(initialState.password)
    const [errors, setErrors] = useState(initialState.errors)

    const theme = useTheme()

    const appContext = useContext(_appContext)
    const authContext = useContext(_userContext)

    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

    const getSignInButton = () => {
        return (
            <Button
                color="primary"
                disabled={!emailAddress}
                variant="contained"
                onClick={() => signIn()}
            >
                Вход
            </Button>
        )
    }

    const signIn = async () => {
        setPassword('')
        const errors = validate(
            {
                email: emailAddress,
            },
            {
                email: constraints.email,
            }
        )

        if (errors) {
            setErrors(errors)
        } else {
            setErrors(null)

            await authContext
                .signIn(emailAddress, password)
                .then(user => {
                    appContext.snackbar.showSnackbarMsg(
                        `Вы зашли как ${user.displayName || user.email}`
                    )
                })
                .catch(reason => {
                    if (reason === undefined) {
                        appContext.snackbar.showSnackbarMsg(
                            'Произошла ошибка при входе'
                        )
                        return
                    }
                    const code = reason.code
                    const originalMessage = reason.message
                    let clientMessage = reason.message

                    console.log(reason)
                    switch (code) {
                        case 'auth/user-not-found':
                            clientMessage = 'Пользователь не найден'
                            break
                        case 'auth/web-storage-unsupported':
                            clientMessage =
                                'Настройки вашего браузера не позволяют провести авторизацию'
                            break
                        case 'auth/user-disabled':
                            clientMessage = 'Пользователь недоступен'
                            break
                        case 'auth/wrong-password':
                            clientMessage = 'Неверный пароль'
                            break
                        case 'auth/too-many-requests':
                            clientMessage =
                                'Слишком много запросов. Попробуйте позже'
                            break
                        default:
                            clientMessage = originalMessage
                    }

                    appContext.snackbar.showSnackbarMsg(clientMessage)
                })
        }
    }

    const handleExited = () => {
        setPerformingAction(initialState.performingAction)
        setEmailAddress(initialState.emailAddress)
        setPassword(initialState.password)
        setErrors(initialState.errors)
    }

    const handleEmailAddressChange = event =>
        setEmailAddress(event.target.value)
    const handlePasswordChange = event => setPassword(event.target.value)

    return (
        <Dialog
            fullScreen={fullScreen}
            fullWidth
            maxWidth="sm"
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
            // onKeyPress={this.handleKeyPress}
            onExited={handleExited}
            open={true}
        >
            <DialogTitle disableTypography>
                <Typography variant="h6">Авторизация пользователя</Typography>
            </DialogTitle>

            <DialogContent>
                <Hidden xsDown>
                    <Grid container direction="row">
                        {/* <Grid item xs={4}> */}
                        {/* <AuthProviderList
                  performingAction={performingAction}
                //   onAuthProviderClick={this.signInWithAuthProvider}
                /> */}
                        {/* </Grid> */}

                        {/* <Grid item xs={1}>
                <Divider className={classes.divider} orientation="vertical" />
              </Grid> */}

                        <Grid item xs={12}>
                            <Grid container direction="column" spacing={2}>
                                <Grid item xs>
                                    <TextField
                                        autoComplete="email"
                                        //   disabled={performingAction}
                                        error={!!(errors && errors.email)}
                                        fullWidth
                                        helperText={
                                            errors && errors.email
                                                ? errors.email[0]
                                                : ''
                                        }
                                        label="Электронная почта"
                                        // placeholder="john@doe.com"
                                        required
                                        size={'medium'}
                                        type="email"
                                        value={emailAddress}
                                        variant="outlined"
                                        onChange={handleEmailAddressChange}
                                    />
                                </Grid>

                                <Grid item xs>
                                    <TextField
                                        autoComplete="current-password"
                                        //   disabled={performingAction}
                                        error={!!(errors && errors.password)}
                                        fullWidth
                                        helperText={
                                            errors && errors.password
                                                ? errors.password[0]
                                                : ''
                                        }
                                        label="Пароль"
                                        placeholder="&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;"
                                        required
                                        size={'medium'}
                                        type="password"
                                        value={password}
                                        variant="outlined"
                                        onChange={handlePasswordChange}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Hidden>

                <Hidden smUp>
                    {/* <AuthProviderList
              gutterBottom
              performingAction={performingAction}
            //   onAuthProviderClick={this.signInWithAuthProvider}
            /> */}

                    <Grid container direction="column" spacing={2}>
                        <Grid item xs>
                            <TextField
                                autoComplete="email"
                                error={!!(errors && errors.emailAddress)}
                                fullWidth
                                helperText={
                                    errors && errors.emailAddress
                                        ? errors.emailAddress[0]
                                        : ''
                                }
                                label="Почта"
                                placeholder="john@doe.com"
                                required
                                size={'medium'}
                                type="email"
                                value={emailAddress}
                                variant="outlined"
                                onChange={handleEmailAddressChange}
                            />
                        </Grid>

                        <Grid item xs>
                            <TextField
                                autoComplete="current-password"
                                error={!!(errors && errors.password)}
                                fullWidth
                                helperText={
                                    errors && errors.password
                                        ? errors.password[0]
                                        : ''
                                }
                                label="Пароль"
                                placeholder="&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;"
                                required
                                size={'medium'}
                                type="password"
                                value={password}
                                variant="outlined"
                                onChange={handlePasswordChange}
                            />
                        </Grid>
                    </Grid>
                </Hidden>
            </DialogContent>

            <DialogActions>{getSignInButton()}</DialogActions>
        </Dialog>
    )
}

export default SignInDialog
